export const textBannersStateMapping = {
  EDIT: 'edit',
  CREATE: 'create',
  REVIEW: 'review',
};
